import { BoxProps, CSSObject } from '@chakra-ui/react';

export const wrapper: BoxProps = {};

export const TextFormInfo: CSSObject = {
  color: 'gray.500',
  fontWeight: 'medium',
  fontSize: 'xs',
};
